import React, { useState } from 'react';

const REASONS = [
  "Je n'utilise plus l'application",
  "Problème de confidentialité",
  "Trop de notifications",
  "Problèmes techniques",
  "Autre raison"
];

const DeleteAccount: React.FC = () => {
  const [form, setForm] = useState({ phone: '', reason: '', details: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // Ici, tu pourrais envoyer le formulaire à une API pour traiter la suppression
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-8 px-4">
      <div className="w-full max-w-lg bg-white rounded-lg shadow-md p-8">
        <h1 className="text-2xl font-bold mb-4 text-center text-red-600">Suppression de compte</h1>
        <p className="mb-6 text-center text-gray-600">Nous sommes désolés de vous voir partir. Veuillez renseigner votre numéro de téléphone et la raison de votre départ.</p>
        {submitted ? (
          <div className="text-green-600 text-center font-semibold py-8">Votre demande de suppression a bien été prise en compte.<br/>Nous traiterons votre demande dans les plus brefs délais.</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="phone" className="block text-gray-700 font-medium mb-1">Numéro de téléphone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                required
                placeholder="Ex: +243 000 000 000"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-400"
              />
            </div>
            <div>
              <label htmlFor="reason" className="block text-gray-700 font-medium mb-1">Raison de la suppression</label>
              <select
                id="reason"
                name="reason"
                value={form.reason}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-400"
              >
                <option value="">-- Sélectionnez une raison --</option>
                {REASONS.map((r) => (
                  <option key={r} value={r}>{r}</option>
                ))}
              </select>
            </div>
            {form.reason === 'Autre raison' && (
              <div>
                <label htmlFor="details" className="block text-gray-700 font-medium mb-1">Détails (optionnel)</label>
                <textarea
                  id="details"
                  name="details"
                  value={form.details}
                  onChange={handleChange}
                  rows={3}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
            )}
            <button
              type="submit"
              className="w-full bg-red-600 text-white font-semibold py-2 rounded hover:bg-red-700 transition-colors"
            >
              Supprimer mon compte
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount; 